import { Box } from "@mui/material";
import HowToSellContent from "../components/HowToSellContent";

const HowToSell = () => {
  return (
    <Box>
      <HowToSellContent />
      
    </Box>
  );
};

export default HowToSell;
